import React, { Component } from 'react'
import c from 'classnames'
import PropTypes from 'prop-types'
import Image from 'src/components/image'
import closeBtn from 'src/assets/desktop-close-btn.svg'
import { dispatch } from 'src/store'
import { setShouldShowUseCases } from 'src/actions'

export class FrameCloseBtn extends Component {
  static propTypes = {
    className: PropTypes.string,
  }

  static defaultProps = {
    className: '',
  }

  get className() {
    const { className } = this.props
    return c('im-frame-close-btn', className)
  }

  render() {
    const { className } = this
    return (
      <div className={className} onClick={() => dispatch(setShouldShowUseCases(false))}>
        <Image src={closeBtn} alt="Close Use Cases" />
      </div>
    )
  }
}

export default FrameCloseBtn
